'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createField = require('./createField');

var _createField2 = _interopRequireDefault(_createField);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createField2.default)(_plain2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/Field.js
// module id = 60
// module chunks = 0